import type { ActionModel } from '@jet/environment/types/models';

export interface UserComponentsAction extends ActionModel {
    $kind: 'userComponentsAction';
    url: string;
    actionType: 'fetch' | 'perform';
    payload: any;
}

export function makeUserComponentsAction(
    url: string,
    actionType: 'fetch' | 'perform' = 'fetch',
    payload: any = {},
): UserComponentsAction {
    return {
        $kind: 'userComponentsAction',
        url,
        actionType,
        payload,
        actionMetrics: {
            data: [],
            custom: {},
        },
    };
}
